import React from 'react';
import { CheckIcon, ArrowRightIcon, UserIcon } from 'lucide-react';
const JoinOthers: React.FC = () => {
  return <section className="w-full py-16 px-4 bg-[#0A1020]" data-id="element-116">
      <div className="max-w-5xl mx-auto" data-id="element-117">
        <h2 className="text-3xl font-bold mb-8 text-center" data-id="element-118">
          GÖR SOM TUSENTALS ANDRA MÄN - TESTA VeeloBooster IDAG!
        </h2>
        <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-119">
          <div className="flex-1" data-id="element-120">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/m4MgbYDZypEpGvskPmimaD/8ae3e179-7084-4dd9-bbea-91f472905c98.png" alt="Man med VeeloBooster" className="w-full h-auto rounded-xl" data-id="element-121" />
          </div>
          <div className="flex-1 space-y-6" data-id="element-122">
            <h3 className="text-2xl font-semibold" data-id="element-123">
              Upplev kraften i VeeloBooster
            </h3>
            <p className="text-gray-300" data-id="element-124">
              Tusentals män har redan upptäckt hur VeeloBooster kan förbättra
              deras sexuella hälsa och prestationsförmåga. Nu är det din tur att
              uppleva skillnaden.
            </p>
            <div className="space-y-4" data-id="element-125">
              <div className="flex items-start" data-id="element-126">
                <div className="mr-3 mt-1" data-id="element-127">
                  <CheckIcon className="w-5 h-5 text-[#10C96C]" data-id="element-128" />
                </div>
                <p data-id="element-129">Kraftigare och mer långvariga erektioner</p>
              </div>
              <div className="flex items-start" data-id="element-130">
                <div className="mr-3 mt-1" data-id="element-131">
                  <CheckIcon className="w-5 h-5 text-[#10C96C]" data-id="element-132" />
                </div>
                <p data-id="element-133">Ökad sexlust och förbättrad prestationsförmåga</p>
              </div>
              <div className="flex items-start" data-id="element-134">
                <div className="mr-3 mt-1" data-id="element-135">
                  <CheckIcon className="w-5 h-5 text-[#10C96C]" data-id="element-136" />
                </div>
                <p data-id="element-137">Mer energi och uthållighet hela natten</p>
              </div>
            </div>
            <a href="https://www.fasttrack39.com/Q2F67GN8/2K64K71K/" className="inline-flex items-center px-6 py-3 bg-[#0EB7FF] hover:bg-[#0EA7EF] text-black font-semibold rounded-md transition-all" data-id="element-138">
              Prova VeeloBooster nu
              <ArrowRightIcon className="w-4 h-4 ml-2" data-id="element-139" />
            </a>
          </div>
        </div>
        <div className="mt-10 bg-gray-900 rounded-xl p-6" data-id="element-140">
          <div className="flex flex-col md:flex-row items-center gap-6" data-id="element-141">
            <div className="md:w-1/3" data-id="element-142">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sDW5v3ZLmCktZ9huBSeYKc/8740d681-3bec-400a-b4c5-4ddb33f24324.png" alt="Nöjd VeeloBooster användare" className="w-full h-auto rounded-lg shadow-lg" data-id="element-143" />
            </div>
            <div className="md:w-2/3 space-y-4" data-id="element-144">
              <div className="flex items-center" data-id="element-145">
                <UserIcon className="w-5 h-5 text-[#0EB7FF] mr-2" data-id="element-146" />
                <h3 className="font-semibold text-lg" data-id="element-147">Oskar, 23 år</h3>
              </div>
              <p className="text-gray-300 italic" data-id="element-148">
                "Jag var skeptisk i början, men VeeloBooster har verkligen
                överträffat mina förväntningar. Min självkänsla har förbättrats
                avsevärt och min partner märker verkligen skillnaden.
                Rekommenderar starkt!"
              </p>
              <div className="flex space-x-1" data-id="element-149">
                {[...Array(5)].map((_, i) => <svg key={i} xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-yellow-400 fill-current" viewBox="0 0 20 20" data-id="element-150">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-151" />
                  </svg>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default JoinOthers;